// Sign Up page (.tp-signup) — free-session form: client-side validation +
// success state. Email + phone are format-validated; the phone auto-formats to
// +1 (023) 456-7890 as you type (matches the home lead form).
document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.tp-signup');
    if (!root) {
        return;
    }
    var form = root.querySelector('.cs-form');
    if (!form) {
        return;
    }

    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var PHONE_RE = /^\+1 \(\d{3}\) \d{3}-\d{4}$/;

    function formatPhone(val) {
        var digits = val.replace(/\D/g, '');
        if (digits.length > 0 && digits[0] === '1') {
            digits = digits.slice(1);
        }
        digits = digits.slice(0, 10);
        if (!digits) {
            return '';
        }
        var r = '+1 (' + digits.slice(0, 3);
        if (digits.length > 3) { r += ') ' + digits.slice(3, 6); }
        if (digits.length > 6) { r += '-' + digits.slice(6, 10); }
        return r;
    }

    var first = form.querySelector('[name="first_name"]');
    var last = form.querySelector('[name="last_name"]');
    var email = form.querySelector('[name="email"]');
    var phone = form.querySelector('[name="phone"]');
    var info = form.querySelector('[name="info"]');
    var errEl = form.querySelector('.cs-error');
    var submit = form.querySelector('.cs-form__submit');
    var reset = form.querySelector('.cs-form__reset');
    var nameTarget = form.querySelector('[data-name-target]');

    function showErr(msg) {
        if (errEl) {
            errEl.textContent = msg;
            errEl.style.display = 'block';
        }
    }
    function clearErr() {
        if (errEl) {
            errEl.textContent = '';
            errEl.style.display = 'none';
        }
    }

    [first, last, email, phone, info].forEach(function (el) {
        if (el) {
            el.addEventListener('input', clearErr);
        }
    });

    // Live phone formatting.
    if (phone) {
        phone.addEventListener('input', function () {
            var pos = phone.selectionStart;
            var oldLen = phone.value.length;
            phone.value = formatPhone(phone.value);
            var delta = phone.value.length - oldLen;
            phone.setSelectionRange(pos + delta, pos + delta);
        });
    }

    if (submit) {
        submit.addEventListener('click', function (e) {
            e.preventDefault();
            if (!first || !first.value.trim() || !last || !last.value.trim()) {
                showErr('Please enter your first and last name.');
                return;
            }
            if (!email || !EMAIL_RE.test(email.value.trim())) {
                showErr('Please enter a valid email address.');
                return;
            }
            if (!phone || !PHONE_RE.test(phone.value.trim())) {
                showErr('Please enter a valid phone number so we can reach you.');
                return;
            }
            clearErr();
            if (nameTarget) {
                nameTarget.textContent = first.value.trim();
            }
            root.classList.add('is-sent');
        });
    }

    if (reset) {
        reset.addEventListener('click', function () {
            form.querySelectorAll('input, textarea').forEach(function (el) {
                el.value = '';
            });
            clearErr();
            root.classList.remove('is-sent');
        });
    }
});
